import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/auth-context';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import CampaignsPage from './pages/CampaignsPage';
import OrdersPage from './pages/OrdersPage';
import AccountsPage from './pages/AccountsPage';
import LogList from './components/LogList';
import GoogleSheetsManager from './components/GoogleSheetsManager';
import RuleManager from './components/RuleManager';
import Login from './pages/Login';
import Register from './pages/Register';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Navigate to="/campaigns" replace />} />
                    <Route path="/campaigns" element={<CampaignsPage />} />
                    <Route path="/orders" element={<OrdersPage />} />
                    <Route path="/accounts" element={<AccountsPage />} />
                    <Route path="/rules" element={<RuleManager />} />
                    <Route path="/logs" element={<LogList />} />
                    <Route path="/sheets" element={<GoogleSheetsManager />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;